/* Wide Angle part product page. Loaded only when the preview gate is on, by
 * sections/open-road-product-docket.liquid. Spec: prototypes/direction-wide-angle/shop.html.
 *
 *   Gallery   thumbnails, arrows, swipe, hover zoom, "n / N" count
 *   Buy box   line total on the add button, free-delivery box, sold-out sync
 *   Sticky    the add bar shows once the buy box add button scrolls out of view
 *   Bundle    "Often fitted alongside": recommendations (complementary, then
 *             related) as tick-to-add items, added in one /cart/add.js call
 *
 * The variant picker stays open-road-docket-variants.js: it swaps the price,
 * stock stamp, hidden id and quantity rules and clicks the matching thumbnail.
 * This file only listens to the same change and fills in the extras.
 * Money is formatted with Intl in the shop currency; Liquid formats every
 * first render, so a page without JS still shows correct prices.
 */
(function () {
  var root = document.querySelector('[data-wa-pdp]');
  if (!root) return;

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  var locale = document.documentElement.lang || 'en-GB';
  function money(cents) {
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  /* ---------- Gallery ---------- */
  function initGallery() {
    var gal = $('[data-wa-gal]');
    if (!gal) return;
    var main = $('[data-wa-gal-main]', gal);
    var img = $('[data-wa-gal-img]', gal);
    var count = $('[data-wa-gal-count]', gal);
    var thumbs = $$('[data-wa-thumb]', gal);
    var index = 0;

    function show(i) {
      if (!thumbs.length) return;
      index = (i + thumbs.length) % thumbs.length;
      var t = thumbs[index];
      img.removeAttribute('srcset');
      img.src = t.dataset.src;
      if (t.dataset.srcset) img.setAttribute('srcset', t.dataset.srcset);
      img.alt = t.dataset.alt || img.alt;
      thumbs.forEach(function (b, k) {
        b.classList.toggle('is-on', k === index);
        if (k === index) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      if (count) count.textContent = (index + 1) + ' / ' + thumbs.length;
      var box = t.parentElement;
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var behave = still ? 'auto' : 'smooth';
      if (box && box.scrollTo) {
        var horizontal = box.scrollWidth > box.clientWidth;
        if (horizontal) box.scrollTo({ left: t.offsetLeft - box.clientWidth / 2 + t.clientWidth / 2, behavior: behave });
        else box.scrollTo({ top: t.offsetTop - box.clientHeight / 2 + t.clientHeight / 2, behavior: behave });
      }
    }

    gal.addEventListener('click', function (e) {
      var t = e.target.closest('[data-wa-thumb]');
      if (t) { show(+t.dataset.waThumb); return; }
      var step = e.target.closest('[data-wa-gal-step]');
      if (step) { e.stopPropagation(); show(index + (+step.dataset.waGalStep)); }
    });
    main.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { show(index + 1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { show(index - 1); e.preventDefault(); }
    });

    /* Hover zoom follows the pointer; mice only, never on touch. */
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (fine) {
      main.addEventListener('mousemove', function (e) {
        if (e.target.closest('.wa-gal__nav')) { main.classList.remove('is-zoom'); return; }
        var r = main.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        main.classList.add('is-zoom');
      });
      main.addEventListener('mouseleave', function () { main.classList.remove('is-zoom'); });
    }

    /* Swipe: a horizontal drag of 40px or more changes photo. */
    var sx = null, sy = null;
    main.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      sx = e.clientX; sy = e.clientY;
    });
    main.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      sx = sy = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
    });
    main.addEventListener('pointercancel', function () { sx = sy = null; });

    if (thumbs.length) {
      main.setAttribute('tabindex', '0');
      main.setAttribute('role', 'group');
      main.setAttribute('aria-label', 'Product photos. Use the left and right arrow keys to change photo.');
    }
    root.__waShow = show;
  }

  /* ---------- Buy box ---------- */
  var variants = [];
  try { variants = JSON.parse(($('[data-wa-variants]') || {}).textContent || '[]'); } catch (e) { variants = []; }
  var idInput = $('.product-variant-id');
  var qtyInput = $('.wa-buy .quantity__input');
  var addBtn = $('[data-wa-add]');
  var sbarAdd = document.querySelector('[data-wa-sbar-add]');
  var threshold = +root.dataset.threshold || 0;
  var basket = +root.dataset.basket || 0;
  var cartVariants = [];

  function current() {
    var id = idInput ? +idInput.value : 0;
    for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
    return variants[0] || null;
  }
  function qty() {
    var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    var mn = qtyInput ? (parseInt(qtyInput.min, 10) || 1) : 1;
    return isNaN(q) || q < mn ? mn : q;
  }

  function update() {
    var v = current();
    if (!v) return;
    var line = v.price * qty();
    var total = $('[data-wa-line-total]');
    if (total) total.textContent = '\u00b7 ' + money(line);

    var was = $('[data-wa-was]');
    if (was) {
      var on = v.compare > v.price;
      was.hidden = !on;
      was.textContent = on ? money(v.compare) : '';
    }
    var pill = $('[data-wa-okpill]');
    if (pill) pill.hidden = !(threshold > 0 && v.price >= threshold);

    var ship = $('[data-wa-ship]');
    if (ship && threshold > 0) {
      /* The box states the real cart position. The item on show is only ever a
         separate hypothetical line, and only while it is not already in the cart. */
      var sum = basket;
      var msg = $('[data-wa-ship-msg]', ship);
      var bar = $('[data-wa-ship-bar]', ship);
      if (msg) {
        msg.textContent = sum >= threshold
          ? root.dataset.msgAbove
          : (root.dataset.msgBelow || '').replace('[amount]', money(threshold - sum));
      }
      var withEl = $('[data-wa-ship-with]', ship);
      if (withEl) {
        var show = sum < threshold && v.available && cartVariants.indexOf(v.id) === -1;
        var after = sum + line;
        withEl.hidden = !show;
        withEl.textContent = !show ? '' : (after >= threshold
          ? ' With this item: your order would qualify for free UK delivery.'
          : ' With this item: ' + money(threshold - after) + ' more to go.');
      }
      if (bar) bar.style.width = Math.min(100, sum / threshold * 100).toFixed(1) + '%';
    }

    var sp = document.querySelector('[data-wa-sbar-price]');
    if (sp) sp.textContent = money(v.price);
    if (sbarAdd && addBtn) {
      sbarAdd.disabled = addBtn.disabled;
      sbarAdd.textContent = addBtn.disabled ? (addBtn.querySelector('span') || addBtn).textContent : 'Add to cart';
    }

    /* The bundle always starts from the variant on show. */
    var self = document.querySelector('[data-wa-bitem-self]');
    if (self) {
      self.dataset.variant = v.id;
      self.dataset.price = v.price;
      self.dataset.qty = qty();
      /* A sold-out variant cannot go in the bundle: untick it and show it off. */
      self.checked = !!v.available;
      var selfItem = self.closest('.wa-bitem');
      if (selfItem) selfItem.classList.toggle('is-off', !v.available);
      var p = document.querySelector('[data-wa-bitem-self-price]');
      if (p) p.textContent = money(v.price * qty());
      bundleTotals();
    }
  }

  /* docket-variants listens on its own element; this runs after it. */
  document.addEventListener('change', function (e) {
    if (e.target.closest && (e.target.closest('docket-variants') || e.target === qtyInput)) update();
  });
  if (qtyInput) qtyInput.addEventListener('input', update);

  function refreshBasket() {
    fetch((window.routes && routes.cart_url ? routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        basket = c.total_price || 0;
        cartVariants = (c.items || []).map(function (i) { return i.variant_id; });
        update();
      })
      .catch(function () {});
  }
  /* pubsub.js loads deferred in the head, so subscribe exists by the time this deferred file runs. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshBasket);

  /* ---------- Sticky add bar ---------- */
  function initSbar() {
    var bar = document.querySelector('[data-wa-sbar]');
    var anchor = addBtn || $('.wa-collect .wa-add') || $('[data-wa-buy]');
    if (!bar || !anchor) return;
    var state = null;
    function set(on) {
      if (on === state) return;
      state = on;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      document.body.classList.toggle('wa-sbar-on', on);
    }
    /* A scroll check, not an IntersectionObserver: a jump straight back to the top
       (home key, anchor link) never crosses the viewport, so an observer would
       leave the bar showing over the buy box. On only once the add button has
       gone off the top, never before it first scrolls into view. */
    var queued = false;
    function check() {
      queued = false;
      set(anchor.getBoundingClientRect().bottom < 0);
    }
    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(check);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
  }

  /* ---------- Bundle: often fitted alongside ---------- */
  var bundle = document.querySelector('[data-wa-bundle]');
  function bundleBoxes() { return bundle ? Array.prototype.slice.call(bundle.querySelectorAll('[data-wa-bitem]')) : []; }
  function bundleTotals() {
    if (!bundle) return { n: 0, sum: 0 };
    var n = 0, sum = 0;
    bundleBoxes().forEach(function (c) {
      var item = c.closest('.wa-bitem');
      if (item && !item.classList.contains('is-lock')) item.classList.toggle('is-off', !c.checked);
      if (c.checked) { n++; sum += (+c.dataset.price || 0) * (+c.dataset.qty || 1); }
    });
    var t = bundle.querySelector('[data-wa-btotal]');
    if (t) t.textContent = money(sum);
    var b = bundle.querySelector('[data-wa-badd]');
    if (b) {
      b.textContent = 'Add ' + n + ' to cart';
      b.disabled = n === 0;
    }
    return { n: n, sum: sum };
  }

  function loadBundle() {
    if (!bundle || !bundle.dataset.url) return;
    function get(intent) {
      return fetch(bundle.dataset.url + '&intent=' + intent)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var d = document.createElement('div');
          d.innerHTML = html;
          var src = d.querySelector('[data-wa-bundle-src]');
          return src ? Array.prototype.slice.call(src.querySelectorAll('.wa-bitem')) : [];
        })
        .catch(function () { return []; });
    }
    get('complementary').then(function (items) {
      return items.length ? items : get('related');
    }).then(function (items) {
      if (!items.length) return;
      var box = bundle.querySelector('[data-wa-bitems]');
      items.forEach(function (it) { box.appendChild(it); });
      bundle.hidden = false;
      bundleTotals();
    });
  }

  function initBundle() {
    if (!bundle) return;
    bundle.addEventListener('change', function (e) { if (e.target.matches('[data-wa-bitem]')) bundleTotals(); });
    var btn = bundle.querySelector('[data-wa-badd]');
    var err = bundle.querySelector('[data-wa-berr]');
    btn.addEventListener('click', function () {
      var items = bundleBoxes().filter(function (c) { return c.checked; }).map(function (c) {
        return { id: +c.dataset.variant, quantity: +c.dataset.qty || 1 };
      });
      if (!items.length) return;
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
        drawer.setActiveElement && drawer.setActiveElement(btn);
      }
      btn.classList.add('loading');
      btn.setAttribute('aria-disabled', 'true');
      if (err) err.hidden = true;
      fetch((window.routes && routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            if (err) { err.textContent = res.description || res.message || 'Could not add these items.'; err.hidden = false; }
            return;
          }
          if (!drawer) { window.location = (window.routes && routes.cart_url) || '/cart'; return; }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wa-bundle', cartData: res });
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        })
        .catch(function () {
          if (err) { err.textContent = 'Could not add these items. Please try again.'; err.hidden = false; }
        })
        .finally(function () {
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
        });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        loadBundle();
      }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(bundle.parentElement || bundle);
    } else {
      loadBundle();
    }
  }

  function init() {
    initGallery();
    initSbar();
    initBundle();
    update();
    refreshBasket();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
